import { render } from "./LoadingPage.vue?vue&type=template&id=3a1ed7b4"
import script from "./LoadingPage.vue?vue&type=script&lang=js"
export * from "./LoadingPage.vue?vue&type=script&lang=js"

import "./LoadingPage.vue?vue&type=style&index=0&id=3a1ed7b4&scope=true&lang=css"
script.render = render

export default script